import React, {useContext} from 'react';
import { LocaleContext } from '../common/App';
import { Footer } from './WebsiteCommon';
import { SuspenseComp } from './Imprint';
import PrivacyPolicyCookiesDe from './de/PrivacyPolicyCookiesDe';
import PrivacyPolicyCookiesEn from './en/PrivacyPolicyCookiesEn';
import { useIndexUpdate } from '../common/hooks';

export function PrivacyPolicyCookies(props) {
    const locale = useContext(LocaleContext);

    useIndexUpdate(props.indexUpdate, locale);

    return (
        <div>
            <div className="bottom_padding side_padding flex_col margin_to_header">
                {
                    locale.locale === "de" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <PrivacyPolicyCookiesDe />
                        </React.Suspense>
                    : locale.locale === "en" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <PrivacyPolicyCookiesEn />
                        </React.Suspense>
                    :
                        null
                }
            </div>

            <Footer />
        </div>
    );
}
